import * as Yup from "yup"

export const createPJPSchema = Yup.object().shape({
  sr: Yup.string().required("This value is required"),
  route: Yup.string().required("This value is required"),
  month: Yup.string().required("This value is required"),
  day: Yup.string().required("This value is required"),
})
